'use client';

import NextError from 'next/error';
import { useEffect } from 'react';
import { errorTracker } from '@/app/services/errorTracking';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    try {
      errorTracker.captureException(error);
    } catch (telemetryError) {
      // Silently handle telemetry errors to prevent secondary failures
      // that could cause the error boundary to re-trigger
      console.warn('Failed to capture error telemetry:', telemetryError);
    }
  }, [error]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
